export default __webpack_public_path__ + "static/media/3.caa6b3c5.jpg";